import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import Iframe from 'react-iframe'
import { withTranslation, Trans } from 'react-i18next';
import NewHeader from './NewHeader';
import NewFooter from './NewFooter';
import WbtcLiveChart from './WbtcLiveChart';
import NumberFormat from 'react-number-format';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

// Fixed, non-sliding grid: every market box below shows a flat 5-item list instead of a carousel.
const FIXED_GRID_SIZE = 5;

// Flip to false to bring back real coin/exchange/wallet/blockchain data in the boxes below.
const SHOW_AD_PLACEHOLDER = true;

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      markets: [],
      some_markets: [],
      ads: [],
      perPage: 20,
      current_tab: '',
      offset: 0,
      currentPage: 0,
      offset_fav: 0,
      currentPage_fav: 0,
      NewsperPage: 3,
      loading: true,
      api_url: process.env.REACT_APP_API_URL,
      crypto_api_url: process.env.REACT_APP_CRYPTO_API_URL,
      uploaded_image_url: process.env.REACT_APP_CRYPTO_API_URL+'images/',
      sponsor_exchange: [],
      sponsor_wallet: [],
      sponsor_blockchain: [],
      new_exchange: [],
      new_wallet: [],
      new_blockchain: [],
      new_token: [],
      new_coins: [],
      earn_crypto: [],
      utility: [],
      crypto_merchants: [],
      custom_currency: null,
      fourthActiveTab: 'utility',
      showFourthCarousel: true,
      thirdActiveTab: 'new-exchange',
      showThirdCarousel: true,
      secondActiveTab: 'new-coin',
      showSecondCarousel: true,
      firstActiveTab: 'sponsor-crypto',
      showFirstCarousel: true,
      isProcessed: false

    };
    this.handleSearch = this.handleSearch.bind(this)
    this.handlePageClick = this.handlePageClick.bind(this);
    this.favCrypto = this.favCrypto.bind(this);
    this.setFavourite = this.setFavourite.bind(this);
    this.setUnFavourite = this.setUnFavourite.bind(this);
    this.loadMoreNews = this.loadMoreNews.bind(this);
    this.saveAdDetail = this.saveAdDetail.bind(this);
    this.setTimeZone = this.setTimeZone.bind(this);
    this.get_total_news = this.get_total_news.bind(this);
    this.get_advertisements = this.get_advertisements.bind(this);
    this.get_exchanges = this.get_exchanges.bind(this);
    this.get_wallet = this.get_wallet.bind(this);
    this.get_blockchain = this.get_blockchain.bind(this);
    this.get_coin = this.get_coin.bind(this);
    this.get_utility = this.get_utility.bind(this);
    this.get_earn_crypto = this.get_earn_crypto.bind(this);
    this.get_crypto_merchants = this.get_crypto_merchants.bind(this);
    this.getCustomCurrency = this.getCustomCurrency.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.fourthActiveTab !== this.state.fourthActiveTab) {
      this.setState({ showFourthCarousel: false });
    }
    if (prevState.thirdActiveTab !== this.state.thirdActiveTab) {
      this.setState({ showThirdCarousel: false });
    }
    if (prevState.secondActiveTab !== this.state.secondActiveTab) {
      this.setState({ showSecondCarousel: false });
    }
    if (prevState.firstActiveTab !== this.state.firstActiveTab) {
      this.setState({ showFirstCarousel: false });
    }
  }
  numberFormat(x) {
    return parseFloat(x).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  componentDidMount() {
    this.TopAd();
    this.getLatestNews();
    this.setTimeZone();
    this.get_total_news();
    this.get_advertisements();

    this.get_exchanges('sponcered')
    this.get_wallet('sponcered')
    this.get_blockchain('sponcered')

    this.get_exchanges('new_arrival')
    this.get_wallet('new_arrival')
    this.get_blockchain('new_arrival')

    this.get_coin(1)
    this.get_coin(0)

    this.get_utility()
    this.get_earn_crypto()
    this.get_crypto_merchants()

    if (this.state.current_tab === 'Fav') {
      this.favCrypto('USD')
    } else {
      this.loadPage('USD')
    }
    this.someMarkets('USD');
    this.getCustomCurrency();

    this.interval = setInterval(() => this.someMarkets('USD'), 45000);
    this.interval1 = setInterval(() => this.loadRate(), 1000);
    this.interval2 = setInterval(() => this.loadBnbSolRate(), 3000);
    this.loadBnbSolRate();
  }
  loadRate() {
  const headerSelectors = {
    BTC: { price: '.header_btcprice', per: '.header_btcper' },
    WBTC: { price: '.header_wbtcprice', per: '.header_wbtcper' },
    ETH: { price: '.header_ethprice', per: '.header_ethper' },
  };

  fetch('/belpay-api/get-live-rate-new')
    .then(response => response.json())
    .then(data => {
      data.forEach((item) => {
        const target = headerSelectors[item.currency];
        if (!target) return;

        const priceEl = document.querySelector(target.price);
        const perEl = document.querySelector(target.per);
        if (!priceEl || !perEl) return;

        priceEl.innerHTML = '$' + this.numberFormat(item.in_USD);
        const percent = parseFloat(item.percent_change_24h).toFixed(2) + '%';
        perEl.innerHTML = item.percent_change_24h < 0
          ? `<span class="low">${percent}</span>`
          : `<span class="high">${percent}</span>`;
      });
    })
    .catch(error => {
      console.error('Error fetching crypto rates:', error);
    });
}

  // belpay.io doesn't track BNB/SOL, so pull those two from CoinGecko's public price feed
  loadBnbSolRate() {
    const renderRate = (selectors, price, percentChange) => {
      const priceEl = document.querySelector(selectors.price);
      const perEl = document.querySelector(selectors.per);
      if (!priceEl || !perEl) return;

      priceEl.innerHTML = '$' + this.numberFormat(price);
      const percent = parseFloat(percentChange).toFixed(2) + '%';
      perEl.innerHTML = percentChange < 0
        ? `<span class="low">${percent}</span>`
        : `<span class="high">${percent}</span>`;
    };

    fetch('https://api.coingecko.com/api/v3/simple/price?ids=binancecoin,solana&vs_currencies=usd&include_24hr_change=true')
      .then(response => response.json())
      .then(data => {
        if (data.binancecoin) {
          renderRate({ price: '.header_bnbprice', per: '.header_bnbper' }, data.binancecoin.usd, data.binancecoin.usd_24h_change);
        }
        if (data.solana) {
          renderRate({ price: '.header_solprice', per: '.header_solper' }, data.solana.usd, data.solana.usd_24h_change);
        }
      })
      .catch(error => {
        console.error('Error fetching BNB/SOL rates:', error);
      });
  }
 

  setTimeZone() {
    let timezone_value = - new Date().getTimezoneOffset() * 60
    fetch(this.state.api_url + '/save_timezone/' + timezone_value, { method: "get" })
      .then((res) => res.json())
      .then((data) => {
      })
      .catch(err => console.log(err))
  }

  resetSearch(current_tab, showCurrency) {
    if (current_tab === 'All') {
      this.loadPage(showCurrency);
    } else {
      this.favCrypto(showCurrency);
    }

  }

  get_total_news() {
    fetch(this.state.api_url + '/get_total_news', { method: "get" })
      .then((res) => res.json())
      .then((total_news_length) => {
        this.setState({ total_news_length })
      })
      .catch(err => console.log(err))
  }

  get_advertisements() {
    fetch(this.state.api_url + '/get_advertisements', { method: "get" })
      .then((res) => res.json())
      .then((ads) => {
        this.setState({ ads })
      })
      .catch(err => console.log(err))
  }
  get_exchanges(type) {
    fetch(this.state.api_url + '/get_exchanges/' + type, { method: "get" })
      .then((res) => res.json())
      .then((ads) => {
        if(type === 'sponcered') {
          this.setState({ sponsor_exchange : ads })
        } else {
          this.setState({ new_exchange : ads })
        }
        
      })
      .catch(err => console.log(err))
  }

  get_wallet(type) {
    fetch(this.state.api_url + '/get_wallet/' + type, { method: "get" })
      .then((res) => res.json())
      .then((ads) => {
        if(type === 'sponcered') {
          this.setState({ sponsor_wallet : ads })
        } else {
          this.setState({ new_wallet : ads })
        }
        
      })
      .catch(err => console.log(err))
  }

  get_crypto_merchants() {
    fetch(this.state.api_url + 'get_crypto_merchants', { method: "get" })
      .then((res) => res.json())
      .then((ads) => {
          this.setState({ crypto_merchants : ads })
      })
      .catch(err => console.log(err))
  }

  get_earn_crypto() {
    fetch(this.state.api_url + 'get_earn_crypto', { method: "get" })
      .then((res) => res.json())
      .then((ads) => {
          this.setState({ earn_crypto : ads })
      })
      .catch(err => console.log(err))
  }

  get_utility() {
    fetch(this.state.api_url + 'get_utility', { method: "get" })
      .then((res) => res.json())
      .then((ads) => {
          this.setState({ utility : ads })
      })
      .catch(err => console.log(err))
  }

  get_blockchain(type) {
    fetch(this.state.api_url + 'get_blockchain/' + type, { method: "get" })
      .then((res) => res.json())
      .then((ads) => {
        if(type === 'sponcered') {
          this.setState({ sponsor_blockchain : ads })
        } else {
          this.setState({ new_blockchain : ads })
        }
        
      })
      .catch(err => console.log(err))
  }

  get_coin(is_token) {
    fetch(this.state.api_url + '/get_coin/' + is_token, { method: "get" })
      .then((res) => res.json())
      .then((ads) => {
        if(is_token === 0) {
          this.setState({ new_coins : ads })
        } else {
          this.setState({ new_token : ads })
        }
        
      })
      .catch(err => console.log(err))
  }



  saveAdDetail(id) {
    fetch(this.state.api_url + '/save_ad_detail/' + id, { method: "get" })
      .then((res) => res.json())
      .then((data) => {
      })
      .catch(err => console.log(err))
  }

  TopAd() {
    fetch(this.state.api_url + '/getAdvertisement/T', { method: "get" })
      .then((res) => res.json())
      .then((data) => {
        const topAdData = data.map((pd, index) => {
          return pd.type === 'M' && (data.length-1) == index ?
            <a key={index} onClick={() => this.saveAdDetail(pd.id)} href={pd.link} className="adbanner" target="_blank" rel="noopener noreferrer"><img src={this.state.uploaded_image_url + pd.image} alt="" className="img-fluid" /> </a>

            : pd.body

        }
        );
        this.setState({ topAdData })
      })
      .catch(err => console.log(err))
  }

  loadMoreNews() {
    let curPerPage = this.state.NewsperPage + 3
    this.setState({ NewsperPage: curPerPage })
    fetch(this.state.api_url + '/get_latest_news/' + curPerPage, { method: "get" })
      .then((res) => res.json())
      .then((latestnews) => {
        const latestnewsData = latestnews.map((pd, index) =>
          <div className="col-lg-4 col-md-6 col-sm-6 pulldevice" key={index}>
            <div className="news-list wow bounceInUp" data-wow-delay="0.4s">
              <a href={'https://cryptoawaaz.ai/news-detail/' + pd.slug} className="news-img" target="_blank" rel="noopener noreferrer">
                <img src={this.state.uploaded_image_url + pd.image} alt="" width="373" height="291" className="img-fluid" />
              </a>
              <div className="news-inner">
                <div className="time-box">{pd.created}</div>
                <h4><a href={'https://cryptoawaaz.ai/news-detail/' + pd.slug} target="_blank" rel="noopener noreferrer">{pd.title}</a></h4>
                <a href={'https://cryptoawaaz.ai/news-detail/' + pd.slug} target="_blank" rel="noopener noreferrer" className="authore">{pd.author_name}</a>
              </div>
            </div>
          </div>
        )
        this.setState({ latestnewsData, 'current_news_length': latestnews.length })
      })
      .catch(err => console.log(err))
  }

  getLatestNews() {
    let curPerPage = this.state.NewsperPage
    this.setState({ NewsperPage: curPerPage })
    fetch(this.state.api_url + '/get_latest_news/' + curPerPage, { method: "get" })
      .then((res) => res.json())
      .then((latestnews) => {
        const latestnewsData = latestnews.map((pd, index) =>
          <div className="col-lg-4 col-md-6 col-sm-6 pulldevice" key={index}>
            <div className="news-list wow bounceInUp" data-wow-delay="0.4s">
              <a href={'https://cryptoawaaz.ai/news-detail/' + pd.slug} className="news-img" target="_blank" rel="noopener noreferrer">
                <img src={this.state.uploaded_image_url + pd.image} alt="" width="373" height="291" className="img-fluid" />
              </a>
              <div className="news-inner">
                <div className="time-box">{pd.created}</div>
                <h4><a href={'https://cryptoawaaz.ai/news-detail/' + pd.slug} target="_blank" rel="noopener noreferrer">{pd.title}</a></h4>
                <a href={'https://cryptoawaaz.ai/news-detail/' + pd.slug} target="_blank" rel="noopener noreferrer" className="authore">{pd.author_name}</a>
              </div>
            </div>
          </div>);
        this.setState({ latestnewsData, 'current_news_length': latestnews.length })
      })
      .catch(err => console.log(err))
  }


  someMarkets(paisa) {
    fetch(this.state.api_url + '/some_markets/' + paisa, { method: "get" })
      .then((res) => res.json())
      .then((some_markets) => {
        this.setState({ some_markets })

      })
      .catch(err => console.log(err))
  }

  // Pins our own WhiteBitcoin (WBTC) listing, priced from belpay.io, on top of the market list.
  // Routed through /belpay-api (see src/setupProxy.js) because belpay.io sends no CORS headers.
  getCustomCurrency() {
    fetch('/belpay-api/live-rate/WBTC')
      .then((res) => res.json())
      .then((data) => {
        const price = Number(data.in_USD) || 0;
        const marketCap = Number(data.market_cap_USD) || 0;
        const volume = Number(data.volume_24h_TUSD) || 0;
        const alreadyLoaded = !!this.state.custom_currency;
        this.setState({
          custom_currency: {
            id: 'wbtc-custom',
            isCustom: true,
            counter: '',
            name: data.currency_name || 'Whitebitcoin',
            symbol: data.currency || 'WBTC',
            slug: 'whitebitcoin',
            image: 'https://api.wbtcprice.io/images/wbtc.png',
            coin_image: 'https://api.wbtcprice.io/images/wbtc.png',
            buy_url: 'https://belpay.io/market-data#/WBTC/WUSD',
            trade_url: 'https://belpay.io/market-data#/WBTC/WUSD',
            earn_url: 'https://belpay.io/market-data#/WBTC/WUSD',
            percent_change_24h: Number(data.percent_change_24h).toFixed(2),
            price: 'USD ' + price.toFixed(price < 1 ? 4 : 2),
            volume_24h: 'USD ' + volume.toLocaleString('en-US', { maximumFractionDigits: 0 }),
            market_cap: 'USD ' + marketCap.toLocaleString('en-US', { maximumFractionDigits: 0 }),
          }
        }, () => {
          // The all-markets fetch may have already resolved without us; refresh once so it appears immediately.
          if (!alreadyLoaded && this.state.current_tab === 'All' && this.state.offset === 0) {
            this.loadPage(this.state.showCurrency);
          }
        })
      })
      .catch(err => console.log(err))
  }

  setFavourite(slug) {
    let fav_storage = localStorage.getItem('fav_ids')
    if (fav_storage) {
      const newids = fav_storage + slug + ','
      localStorage.setItem('fav_ids', newids)
    } else {
      localStorage.setItem('fav_ids', slug + ',')
    }
  }

  setUnFavourite(slug) {
    let fav_storage = localStorage.getItem('fav_ids')
    if (fav_storage) {
      const newids = fav_storage.replace(slug + ',', '');
      localStorage.setItem('fav_ids', newids)
    }
    window.location.reload(true)
  }

  loadPage(paisa) {
    this.setState({ current_tab: "All", showCurrency: paisa })
    fetch(this.state.api_url + '/allmarkets/1/all/All/' + paisa, { method: "get" })
      .then((res) => res.json())
      .then((markets) => {
        this.setState({ loading: false })
        const eosIndex = markets.findIndex((m) => m.symbol === 'EOS')
        if (eosIndex > -1 && eosIndex < 10) {
          const [eos] = markets.splice(eosIndex, 1)
          markets.splice(10, 0, eos)
          markets.forEach((m, i) => { m.counter = i + 1 })
        }
        const displayMarkets = (this.state.offset === 0 && this.state.custom_currency)
          ? [this.state.custom_currency, ...markets]
          : markets
        const slice = displayMarkets.slice(this.state.offset, this.state.offset + this.state.perPage)
        const postData = slice.map((pd, index) => <div key={index}>
           {index == 10 && 
          
          <div className="text-center mid-ad-div">
              <div className="advertisements">
              {this.state.ads.map((ad, index) => {
                if (ad.add_number == 33) {
                  return (
                    <div className="ad container text-center">
                        <a href={`${this.state.api_url}advertise`} target="_blank"><img src={this.state.uploaded_image_url + ad.image} alt="Advertisement" className="img-fluid full-img mobilehide-ad" /></a>
                    </div>
                  );
                }
                else {
                  return null; // important to return something
                }
              })}
            </div>
            </div>
          }
          <div className={"div-base-table-row" + (pd.isCustom ? " featured-row" : "")} key={pd.id} data-row={pd.id} id={"allcrypto_div_id_" + pd.id} >
            <div className="div-base-table-row-inner">

              <div className="tbody-col">
                <div className="table-number">
                  {pd.isCustom ? (
                    <span className="featured-badge" title="Announcement">
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 10v4a1 1 0 0 0 1 1h2l4 4V5L6 9H4a1 1 0 0 0-1 1Z" fill="currentColor" />
                        <path d="M14 9a3 3 0 0 1 0 6M17 6a7 7 0 0 1 0 12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                      </svg>
                    </span>
                  ) : <span>{pd.counter}</span>}
                  <button type="button" className="fa fa-star-o hover-start" onClick={() => { this.setFavourite(pd.symbol) }} ></button>
                </div>
                <div className="listname">
                  {
                    pd.coin_image !== '' &&
                    <img alt="" src={pd.image && pd.image.indexOf('http') === 0 ? pd.image : this.state.uploaded_image_url + pd.image} style={{ 'width': '31px', 'height': '32px' }} />
                  }
                  {
                    pd.coin_image === '' &&
                    <img alt="" src={pd.image && pd.image.indexOf('http') === 0 ? pd.image : this.state.uploaded_image_url + pd.image} style={{ 'width': '31px', 'height': '32px' }} />
                  }

                  <div className="list-title">
                    <a ><h5>{pd.name}</h5></a>
                    <div className="btc-name">{pd.symbol}</div>
                  </div>
                </div>
              </div>

              <div className="tbody-col">
                <div className="innerdiv">
                  <div className="table-doller"><NumberFormat value={pd.price} displayType={'text'} thousandSeparator={true} prefix={'USD '} renderText={value => value} /></div>
                  <div className={(pd.percent_change_24h > 0 ? 'table-precentage high' : 'table-precentage low')}>{pd.percent_change_24h}%</div>
                </div>
              </div>

              <div className="tbody-col">
                <div className="innerdiv">
                  {pd.isCustom ? (
                    <WbtcLiveChart height={100} />
                  ) : (
                    <Iframe url={this.state.api_url + "/small_chart/" + pd.slug}
                      width="144px"
                      height="100px"
                      id="myId"
                      className="myClassname"
                      display="initial"
                      position="relative" frameBorder="0" />
                  )}
                </div>
              </div>

              <div className="tbody-col">
                <div className="innerdiv">
                  <div className="market-precentage">{pd.market_cap}</div>
                </div>
              </div>

              <div className="tbody-col">
                <div className="innerdiv">
                  <div className="hour-value24">{pd.volume_24h}</div>
                </div>
              </div>

              <div className="tbody-col">
                <div className="action-text-right">
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip>Buy</Tooltip>}
                  >
                    <a href={pd.buy_url} target="_blank" rel="noopener noreferrer" className="btn btn-yellow circle-btn" data-toggle="tooltip" data-placement="top" title="Buy">

                      <span>
                        <svg data-name="Layer 2" id="bfa03e94-1cfd-49d4-b6ae-48737bd6e446" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"><polygon points="19 32.475 26.514 24.961 11.486 24.961 19 32.475" /><rect height="2.5" transform="translate(2.58 35.42) rotate(-90)" width="21.79" x="8.105" y="15.17" /></svg>
                      </span>
                    </a>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip>Sell</Tooltip>}
                  >
                    <a href={pd.trade_url} target="_blank" rel="noopener noreferrer" className="btn btn-yellow circle-btn" data-toggle="tooltip" data-placement="top" title="Sell">
                      <span>
                        <svg data-name="Layer 2" id="e3c032bb-e883-433c-b3b1-415a0179788f" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"><polygon points="19 5.525 26.514 13.039 11.486 13.039 19 5.525" /><rect height="2.5" transform="translate(40.58 2.58) rotate(90)" width="21.79" x="8.105" y="20.33" /></svg>
                      </span>
                    </a>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip>Exchange</Tooltip>}
                  >
                    <a href={pd.earn_url} target="_blank" rel="noopener noreferrer" className="btn btn-yellow circle-btn" data-toggle="tooltip" data-placement="top" title="Exchange">
                      <span>
                        <svg data-name="Layer 2" id="a7950d83-8f0b-4d33-b5b1-3b6db61433c0" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"><polygon points="5.525 27.681 13.039 20.167 13.039 35.195 5.525 27.681" /><rect height="2.5" width="21.79" x="10.686" y="26.431" /><polygon points="32.475 10.319 24.961 2.805 24.961 17.833 32.475 10.319" /><rect height="2.5" transform="translate(32.839 20.638) rotate(180)" width="21.79" x="5.525" y="9.069" /></svg>
                      </span>
                    </a>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
          </div>

        </div>

        );

        this.setState({ pageCount: Math.ceil(markets.length / this.state.perPage), postData, current_tab: "All", dataLength: markets.length })
      })
      .catch(err => console.log(err))
  }

  favCrypto(paisa) {
    this.setState({ loading: true })
    let fav_storage = localStorage.getItem('fav_ids')
    if (fav_storage === '') {
      fav_storage = ','
    }
    this.setState({ current_tab: "Fav", showCurrency: paisa })
    fetch(this.state.api_url + '/my_fav_crypto/1/all/All/' + paisa + '/' + fav_storage, { method: "get" })
      .then((res) => res.json())
      .then((favmarkets) => {
        this.setState({ loading: false })
        const slice1 = favmarkets.slice(this.state.offset_fav, this.state.offset_fav + this.state.perPage)
        const favData = slice1.map((pd, index) => <div key={index}>
          <div className="div-base-table-row" key={pd.id} data-row={pd.id} id={"allcrypto_fav_div_id_" + pd.id} >
            <div className="div-base-table-row-inner">

              <div className="tbody-col">
                <div className="table-number">
                  <span>{pd.counter}</span>
                  <button type="button" className="fa fa-star-o hover-start" onClick={() => { this.setUnFavourite(pd.symbol) }} ></button>
                </div>
                <div className="listname">
                  {
                    pd.coin_image !== '' &&
                    <img alt="" src={this.state.uploaded_image_url + pd.image} style={{ 'width': '31px', 'height': '32px' }} />
                  }
                  {
                    pd.coin_image === '' &&
                    <img alt="" src={this.state.uploaded_image_url + pd.image} style={{ 'width': '31px', 'height': '32px' }} />
                  }
                  <div className="list-title">
                    <a ><h5>{pd.name}</h5></a>
                    <div className="btc-name">{pd.symbol}</div>
                  </div>
                </div>
              </div>

              <div className="tbody-col">
                <div className="innerdiv">
                  <div className="table-doller"><NumberFormat value={pd.price} displayType={'text'} thousandSeparator={true} prefix={'USD '} renderText={value => value} /></div>
                  <div className={(pd.percent_change_24h > 0 ? 'table-precentage high' : 'table-precentage low')}>{pd.percent_change_24h}%</div>
                </div>
              </div>

              <div className="tbody-col">
                <div className="innerdiv">
                  <Iframe url={this.state.api_url + "/small_chart/" + pd.slug}
                    width="144px"
                    height="100px"
                    id="myId1"
                    className="myClassname"
                    display="initial"
                    position="relative" frameBorder="0" />
                </div>
              </div>

              <div className="tbody-col">
                <div className="innerdiv">
                  <div className="market-precentage">{pd.market_cap}</div>
                </div>
              </div>

              <div className="tbody-col">
                <div className="innerdiv">
                  <div className="hour-value24">{pd.volume_24h}</div>
                </div>
              </div>

              <div className="tbody-col">
                <div className="action-text-right">
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip>Buy</Tooltip>}
                  >
                    <a href={pd.buy_url} target="_blank" rel="noopener noreferrer" className="btn btn-yellow circle-btn" data-toggle="tooltip" data-placement="top" title="Buy">
                      <span>
                        <svg data-name="Layer 2" id="bfa03e94-1cfd-49d4-b6ae-48737bd6e446" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"><polygon points="19 32.475 26.514 24.961 11.486 24.961 19 32.475" /><rect height="2.5" transform="translate(2.58 35.42) rotate(-90)" width="21.79" x="8.105" y="15.17" /></svg>
                      </span>
                    </a>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip>Sell</Tooltip>}
                  >
                    <a href={pd.trade_url} target="_blank" rel="noopener noreferrer" className="btn btn-yellow circle-btn" data-toggle="tooltip" data-placement="top" title="Sell">
                      <span>
                        <svg data-name="Layer 2" id="e3c032bb-e883-433c-b3b1-415a0179788f" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"><polygon points="19 5.525 26.514 13.039 11.486 13.039 19 5.525" /><rect height="2.5" transform="translate(40.58 2.58) rotate(90)" width="21.79" x="8.105" y="20.33" /></svg>
                      </span>
                    </a>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip>Exchange</Tooltip>}
                  >
                    <a href={pd.earn_url} target="_blank" rel="noopener noreferrer" className="btn btn-yellow circle-btn" data-toggle="tooltip" data-placement="top" title="Exchange">
                      <span>
                        <svg data-name="Layer 2" id="a7950d83-8f0b-4d33-b5b1-3b6db61433c0" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"><polygon points="5.525 27.681 13.039 20.167 13.039 35.195 5.525 27.681" /><rect height="2.5" width="21.79" x="10.686" y="26.431" /><polygon points="32.475 10.319 24.961 2.805 24.961 17.833 32.475 10.319" /><rect height="2.5" transform="translate(32.839 20.638) rotate(180)" width="21.79" x="5.525" y="9.069" /></svg>
                      </span>
                    </a>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
          </div>
        </div>)

        this.setState({ pageCountFav: Math.ceil(favmarkets.length / this.state.perPage), favData, current_tab: "Fav", dataLength: favmarkets.length })
      })
      .catch(err => console.log(err))
  }

  handleSearch(e) {
    let search_keyword = (e.target.value !== '') ? e.target.value : 'all'
    let search_url = this.state.api_url + "/allmarkets/1/" + search_keyword + '/All/' + this.state.showCurrency
    let c_tab = this.state.current_tab
    let id_name = 'allcrypto_div_id_'
    if (c_tab === 'Fav') {
      let fav_storage = localStorage.getItem('fav_ids')
      if (fav_storage === '') {
        fav_storage = ','
      }

      search_url = this.state.api_url + "/my_fav_crypto/1/" + search_keyword + '/All/' + this.state.showCurrency + '/' + fav_storage
      id_name = 'allcrypto_fav_div_id_'
    }
    fetch(search_url,
      {
        method: "get",
      })
      .then((res) => res.json())
      .then((markets) => {
        this.setState({ loading: false })
        const slice = markets.slice(this.state.offset, this.state.offset + this.state.perPage)
        const postData = slice.map((pd, index) => <div key={index}>
          <div className="div-base-table-row" key={pd.id} data-row={pd.id} id={id_name + pd.id}>
            <div className="div-base-table-row-inner">
              <div className="tbody-col">
                <div className="table-number">
                  <span>{pd.counter}</span>
                  {(c_tab === 'All') ? <button type="button" className="fa fa-star-o hover-start" onClick={() => { this.setFavourite(pd.slug) }}></button> : <button type="button" className="fa fa-star-o hover-start" onClick={() => { this.setUnFavourite(pd.slug) }}></button>}
                </div>
                <div className="listname">
                  {
                    pd.coin_image !== '' &&
                    <img alt="" src={pd.coin_image} style={{ 'width': '31px', 'height': '32px' }} />
                  }
                  {
                    pd.coin_image === '' &&
                    <img alt="" src={this.state.uploaded_image_url + pd.image} style={{ 'width': '31px', 'height': '32px' }} />
                  }
                  <div className="list-title">
                    <a ><h5>{pd.name}</h5></a>
                    <div className="btc-name">{pd.symbol}</div>
                  </div>
                </div>
              </div>

              <div className="tbody-col" style={{ 'maxWidth': '120px' }}>
                <div className="innerdiv">
                  <div className="table-doller"><NumberFormat value={pd.price} displayType={'text'} thousandSeparator={true} prefix={'USD '} renderText={value => value} /></div>
                  <div className={(pd.percent_change_24h > 0 ? 'table-precentage high' : 'table-precentage low')}>{pd.percent_change_24h}%</div>
                </div>
              </div>

              <div className="tbody-col" style={{ 'maxWidth': '165px' }}>
                <Iframe url={this.state.api_url + "/small_chart/" + pd.slug}
                  width="144px"
                  height="100px"
                  id="myId"
                  className="myClassname"
                  display="initial"
                  position="relative" frameBorder="0" />
              </div>

              <div className="tbody-col" style={{ 'maxWidth': '140px' }}>
                <div className="market-precentage">{pd.market_cap}</div>
              </div>

              <div className="tbody-col" style={{ 'maxWidth': '135px' }}>
                <div className="hour-value24">{pd.volume_24h}</div>
              </div>

              <div className="tbody-col">
                <div className="action-text-right">
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip>Buy</Tooltip>}
                  >
                    <a href={pd.buy_url} target="_blank" rel="noopener noreferrer" className="btn btn-yellow circle-btn" data-toggle="tooltip" data-placement="top" title="Buy">

                      <span>
                        <svg data-name="Layer 2" id="bfa03e94-1cfd-49d4-b6ae-48737bd6e446" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"><polygon points="19 32.475 26.514 24.961 11.486 24.961 19 32.475" /><rect height="2.5" transform="translate(2.58 35.42) rotate(-90)" width="21.79" x="8.105" y="15.17" /></svg>
                      </span>
                    </a>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip>Sell</Tooltip>}
                  >
                    <a href={pd.trade_url} target="_blank" rel="noopener noreferrer" className="btn btn-yellow circle-btn" data-toggle="tooltip" data-placement="top" title="Sell">
                      <span>
                        <svg data-name="Layer 2" id="e3c032bb-e883-433c-b3b1-415a0179788f" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"><polygon points="19 5.525 26.514 13.039 11.486 13.039 19 5.525" /><rect height="2.5" transform="translate(40.58 2.58) rotate(90)" width="21.79" x="8.105" y="20.33" /></svg>
                      </span>
                    </a>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip>Exchange</Tooltip>}
                  >
                    <a href={pd.earn_url} target="_blank" rel="noopener noreferrer" className="btn btn-yellow circle-btn" data-toggle="tooltip" data-placement="top" title="Exchange">
                      <span>
                        <svg data-name="Layer 2" id="a7950d83-8f0b-4d33-b5b1-3b6db61433c0" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"><polygon points="5.525 27.681 13.039 20.167 13.039 35.195 5.525 27.681" /><rect height="2.5" width="21.79" x="10.686" y="26.431" /><polygon points="32.475 10.319 24.961 2.805 24.961 17.833 32.475 10.319" /><rect height="2.5" transform="translate(32.839 20.638) rotate(180)" width="21.79" x="5.525" y="9.069" /></svg>
                      </span>
                    </a>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
          </div>

        </div>)
        if (c_tab === 'Fav') {
          this.setState({ pageCountFav: Math.ceil(markets.length / this.state.perPage), favData: postData, current_tab: 'Fav', dataLength: markets.length })
        } else {
          this.setState({ pageCount: Math.ceil(markets.length / this.state.perPage), postData, current_tab: 'All', dataLength: markets.length })
        }
      })
      .catch(err => console.log(err))
  }



  handlePageClick = (e) => {
    const selectedPage = e.selected;
    //console.log(selectedPage)
    const offset = selectedPage * this.state.perPage;
    this.setState({
      currentPage: selectedPage,
      offset: offset,
      selectedPage: selectedPage,
    }, () => {
      this.loadPage(this.state.showCurrency)
    });

  };

  handlePageFavClick = (e) => {
    const selectedPage = e.selected;
    const offset_fav = selectedPage * this.state.perPage;
    this.setState({
      currentPage: selectedPage,
      offset_fav: offset_fav,
      selectedPage: selectedPage
    }, () => {
      this.favCrypto(this.state.showCurrency)
    });

  };

  renderAdBox(key) {
    return (
      <div className="item" key={key}>
        <a href={this.state.crypto_api_url + 'advertise'} className="one-five" style={{ 'textDecoration': 'none' }}>
          <div className="market-list ad-placeholder-box">
            <span className="ad-placeholder-badge">Space Available</span>
            <span className="ad-placeholder-icon">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
              </svg>
            </span>
            <h3>Advertise Your Project</h3>
            <span className="ad-placeholder-cta">Get listed here <span aria-hidden="true">&#8594;</span></span>
          </div>
        </a>
      </div>
    );
  }

  render() {
    const _some_markets = this.state.some_markets;
    return (
      <div>
	<NewHeader title={'Markets'} ads={this.state.ads} />
        <section className="markets-bitkart-section">
           
          <div className="container">
            <h1>Cryptocryptocurrencys, Exchanges , Wallets , Blockchains, Business Marketplaces on Crypto Awaaz</h1>

            <div className="clearfix">&nbsp;</div>

      <div className="">
             <div className="exchanges-top-search">

                <ul className="nav nav-pills" id="myTab1" role="tablist">
                  <li className="nav-item">
                    <a className="nav-link active" id="crypto-tab" data-toggle="tab" href="#crypto" role="tab" aria-controls="crypto" aria-selected="true" onClick={() => {
                    this.setState({firstActiveTab: 'sponsor-crypto'})
                    }}><Trans>Sponcered Cryptos</Trans></a>
                  </li>
                  <li className="nav-item">
                    <a onClick={() => {
     this.get_exchanges('sponcered');
     this.setState({firstActiveTab: 'sponsor-exchange'})
   }} className="nav-link" id="exchange-tab" data-toggle="tab" href="#exchange" role="tab" aria-controls="exchange" aria-selected="false" ><Trans>Exchanges</Trans></a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" id="wallet-tab" data-toggle="tab" href="#wallet" role="tab" aria-controls="wallet" aria-selected="false" onClick={() => {
                      this.get_wallet('sponcered');
                      this.setState({firstActiveTab: 'sponsor-wallet'})
                      }}><Trans>Wallets</Trans></a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" id="blockchain-tab" data-toggle="tab" href="#blockchain" role="tab" aria-controls="blockchain" aria-selected="false" onClick={() =>{ 
                      this.get_blockchain('sponcered');
                      this.setState({firstActiveTab: 'sponsor-blockchain'})
                      }}><Trans>Blockchains</Trans></a>
                  </li>
                </ul>

                <div className="clearfix"></div>
              </div>

            <div className="tab-content" id="myTab1Content">
              <div className="tab-pane fade show active" id="crypto" role="tabpanel" aria-labelledby="crypto-tab">
                {this.state.firstActiveTab === 'sponsor-crypto' && <div className="fixed-market-grid">

                  {_some_markets.slice(0, FIXED_GRID_SIZE).map((minirecord, index) => (
                    SHOW_AD_PLACEHOLDER ? this.renderAdBox(`sponsor-crypto${index}`) : (
                    <div className="item" key={index}>
                      <a  className="one-five" style={{ 'textDecoration': 'none' }}>
                        <div className="market-list">

                          <div className="market-top">
                            <strong>
                              {
                                minirecord.image !== '' &&
                                <strong><img alt="" src={this.state.uploaded_image_url + minirecord.image} style={{ 'width': '49px', 'height': '49px' }} /></strong>
                              }
                              {
                                minirecord.image === '' &&
                                <strong><img alt="" src={this.state.uploaded_image_url + minirecord.image} style={{ 'width': '49px', 'height': '49px' }} /></strong>
                              }


                            </strong>
                            <div className="market-list-right">
                              <h3>{minirecord.name}</h3>
                              <p>{minirecord.symbol_upper}</p>
                            </div>
                          </div>

                          <div className="low-high-section">
                            <big><sup>$</sup>{minirecord.price.replace('USD', '')}</big>
                            <span className={(minirecord.percent_change_24h > 0 ? 'high' : 'low')} >{minirecord.percent_change_24h}%</span>
                          </div>


                        </div>

                      </a>
                    </div>
                    )
                  ))}

                </div>}
              </div>
               <div className="tab-pane fade" id="exchange" role="tabpanel" aria-labelledby="exchange-tab">
                 {this.state.firstActiveTab === 'sponsor-exchange' && <div className="fixed-market-grid exchange-tab">

                  {this.state.sponsor_exchange.slice(0, FIXED_GRID_SIZE).map((minirecord, index) => (
                    SHOW_AD_PLACEHOLDER ? this.renderAdBox(`sponsor-exchange${index}`) : (
                    <div className="item" key={`sponsor${index}`}>
                      <a href={minirecord.url} target="_blank" className="one-five" style={{ 'textDecoration': 'none' }}>
                        <div className="market-list">

                          <div className="market-top">
                            <strong>
                              {
                                minirecord.logo_url !== '' &&
                                <strong><img alt="" src={minirecord.logo_url} style={{ 'width': '36px', 'height': '36px' }} /></strong>
                              }
                            </strong>
                            <div className="market-list-right">
                              <h3>{minirecord.name}</h3>
                              <p>{minirecord.url}</p>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                    )
                  ))}

                </div>}
              </div>
               <div className="tab-pane fade" id="wallet" role="tabpanel" aria-labelledby="wallet-tab">
                {this.state.firstActiveTab === 'sponsor-wallet' && <div className="fixed-market-grid">

                  {this.state.sponsor_wallet.slice(0, FIXED_GRID_SIZE).map((minirecord, index) => (
                    SHOW_AD_PLACEHOLDER ? this.renderAdBox(`sponsor-wallet${index}`) : (
                    <div className="item" key={`wallet${index}`}>
                      <a href={minirecord.website_url} target="_blank" className="one-five" style={{ 'textDecoration': 'none' }}>
                        <div className="market-list">

                          <div className="market-top">
                            <strong>
                              {
                                minirecord.logo_url !== '' &&
                                <strong><img alt="" src={minirecord.logo_url} style={{ 'width': '36px', 'height': '36px' }} /></strong>
                              }
                            </strong>
                            <div className="market-list-right">
                              <h3>{minirecord.name}</h3>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                    )
                  ))}

                </div>}
              </div>
               <div className="tab-pane fade" id="blockchain" role="tabpanel" aria-labelledby="blockchain-tab">
                {this.state.firstActiveTab === 'sponsor-blockchain' && <div className="fixed-market-grid">

                  {this.state.sponsor_blockchain.slice(0, FIXED_GRID_SIZE).map((minirecord, index) => (
                    SHOW_AD_PLACEHOLDER ? this.renderAdBox(`sponsor-blockchain${index}`) : (
                    <div className="item" key={`blockchain${index}`}>

                    <a href={minirecord.url} className="one-five" style={{ 'textDecoration': 'none' }}>
                        <div className="market-list">

                          <div className="market-top">
                            <strong>
                              {
                                minirecord.logo !== '' &&
                                <strong><img alt="" src={minirecord.logo} style={{ 'width': '36px', 'height': '36px' }} /></strong>
                              }
                            </strong>
                            <div className="market-list-right">
                              <h3>{minirecord.name}</h3>
                            </div>
                          </div>
                        </div>
                      </a>



                    </div>
                    )
                  ))}

                </div>}
              </div>
            </div>
            </div>


            <div className="text-center mid-ad-div">
              <div className="advertisements">
              {this.state.ads.map((ad, index) => {
                if (ad.add_number == 30) {
                  return (
                    <div className="ad container text-center">
                        <a href={`${this.state.api_url}advertise`} target="_blank"><img src={this.state.uploaded_image_url + ad.image} alt="Advertisement" className="img-fluid full-img mobilehide-ad" /></a>
                    </div>
                  );
                }
                else {
                  return null; // important to return something
                }
              })}
            </div>
            </div>

             <div className="">
             <div className="exchanges-top-search">

                <ul className="nav nav-pills" id="myTab3" role="tablist">
                  <li className="nav-item">
                    <a onClick={() => {
     this.get_coin(0);
     this.setState({secondActiveTab: 'new-coin'})
   }} className="nav-link active" id="new-coin-tab" data-toggle="tab" href="#new-coin" role="tab" aria-controls="new-coin" aria-selected="false" ><Trans>New Arrival Coins</Trans></a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link " id="new-token-tab" data-toggle="tab" href="#new-token" role="tab" aria-controls="new-token" aria-selected="false" onClick={() => {
                      this.get_coin(1);
                      this.setState({secondActiveTab: 'new-token'})
                      }}><Trans>New Arrival Tokens</Trans></a>
                  </li>
                </ul>

                <div className="clearfix"></div>
              </div>

            <div className="tab-content" id="myTab1Content">
               <div className="tab-pane fade show active" id="new-coin" role="tabpanel" aria-labelledby="new-coin-tab">
                  {this.state.secondActiveTab === 'new-coin' && <div className="fixed-market-grid">

                  {this.state.new_coins.slice(0, FIXED_GRID_SIZE).map((minirecord, index) => (
                    SHOW_AD_PLACEHOLDER ? this.renderAdBox(`new-coin${index}`) : (
                    <div className="item" key={`sponsor${index}`}>
                      <a  className="one-five" style={{ 'textDecoration': 'none' }}>
                        <div className="market-list">

                          <div className="market-top">
                            <strong>
                              {
                                minirecord.image !== '' &&
                                <strong><img alt="" src={this.state.uploaded_image_url + minirecord.image} style={{ 'width': '49px', 'height': '49px' }} /></strong>
                              }
                              {
                                minirecord.image === '' &&
                                <strong><img alt="" src={this.state.uploaded_image_url + minirecord.image} style={{ 'width': '49px', 'height': '49px' }} /></strong>
                              }


                            </strong>
                            <div className="market-list-right">
                              <h3>{minirecord.name}</h3>
                              <p>{minirecord.symbol}</p>
                            </div>
                          </div>

                          <div className="low-high-section">
                            <big><sup>$</sup>{minirecord?.price}</big>
                            <span className={(minirecord.percent_change_24h > 0 ? 'high' : 'low')} >{minirecord.percent_change_24h}%</span>
                          </div>


                        </div>

                      </a>
                    </div>
                    )
                  ))}

                </div>}

              </div>
               <div className="tab-pane fade" id="new-token" role="tabpanel" aria-labelledby="new-token-tab">
                {this.state.secondActiveTab === 'new-token' && <div className="fixed-market-grid">

                   {this.state.new_token.slice(0, FIXED_GRID_SIZE).map((minirecord, index) => (
                    SHOW_AD_PLACEHOLDER ? this.renderAdBox(`new-token${index}`) : (
                    <div className="item" key={`sponsortoken${index}`}>
                      <a  className="one-five" style={{ 'textDecoration': 'none' }}>
                        <div className="market-list">

                          <div className="market-top">
                            <strong>
                              {
                                minirecord.image !== '' &&
                                <strong><img alt="" src={this.state.uploaded_image_url + minirecord.image} style={{ 'width': '49px', 'height': '49px' }} /></strong>
                              }
                              {
                                minirecord.image === '' &&
                                <strong><img alt="" src={this.state.uploaded_image_url + minirecord.image} style={{ 'width': '49px', 'height': '49px' }} /></strong>
                              }


                            </strong>
                            <div className="market-list-right">
                              <h3>{minirecord.name}</h3>
                              <p>{minirecord.symbol}</p>
                            </div>
                          </div>

                          <div className="low-high-section">
                            <big><sup>$</sup>{minirecord?.price}</big>
                            <span className={(minirecord.percent_change_24h > 0 ? 'high' : 'low')} >{minirecord.percent_change_24h}%</span>
                          </div>


                        </div>

                      </a>
                    </div>
                    )
                  ))}

                </div>}
              </div>
            </div>
            </div>

            <div className="text-center mid-ad-div">
              <div className="advertisements">
              {this.state.ads.map((ad, index) => {
                if (ad.add_number == 31) {
                  return (
                    <div className="ad container text-center">
                        <a href={`${this.state.api_url}advertise`} target="_blank"><img src={this.state.uploaded_image_url + ad.image} alt="Advertisement" className="img-fluid full-img mobilehide-ad" /></a>
                    </div>
                  );
                }
                else {
                  return null; // important to return something
                }
              })}
            </div>
            </div>

            <div className="">
             <div className="exchanges-top-search">

                <ul className="nav nav-pills" id="myTab2" role="tablist">
                  <li className="nav-item">
                    <a onClick={() => {
     this.get_exchanges('new_arrival');
     this.setState({thirdActiveTab: 'new-exchange'})
   }} className="nav-link active" id="new-exchange-tab" data-toggle="tab" href="#new-exchange" role="tab" aria-controls="new-exchange" aria-selected="false" ><Trans>New Arrival Exchanges</Trans></a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" id="new-wallet-tab" data-toggle="tab" href="#new-wallet" role="tab" aria-controls="new-wallet" aria-selected="false" onClick={() => {
                      this.get_wallet('new_arrival');
                      this.setState({thirdActiveTab: 'new-wallet'})
                    }}><Trans>New Arrival Wallets</Trans></a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" id="new-blockchain-tab" data-toggle="tab" href="#new-blockchain" role="tab" aria-controls="new-blockchain" aria-selected="false" onClick={() => {
                      this.get_blockchain('new_arrival');
                      this.setState({thirdActiveTab: 'new-blockchain'})
                      }}><Trans>New Arrival Blockchains</Trans></a>
                  </li>
                </ul>

                <div className="clearfix"></div>
              </div>

            <div className="tab-content" id="myTab1Content">
               <div className="tab-pane fade show active" id="new-exchange" role="tabpanel" aria-labelledby="new-exchange-tab">
                  {this.state.thirdActiveTab === 'new-exchange' && <div className="fixed-market-grid">

                  {this.state.new_exchange.slice(0, FIXED_GRID_SIZE).map((minirecord, index) => (
                    SHOW_AD_PLACEHOLDER ? this.renderAdBox(`new-exchange${index}`) : (
                    <div className="item" key={`sponsor${index}`}>
                      <a href={minirecord.url} targe="_blank" className="one-five" style={{ 'textDecoration': 'none' }}>
                        <div className="market-list">

                          <div className="market-top">
                            <strong>
                              {
                                minirecord.logo_url !== '' &&
                                <strong><img alt="" src={minirecord.logo_url} style={{ 'width': '36px', 'height': '36px' }} /></strong>
                              }
                            </strong>
                            <div className="market-list-right">
                              <h3>{minirecord.name}</h3>
                              <p>{minirecord.url}</p>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                    )
                  ))}

                </div>}
              </div>
               <div className="tab-pane fade" id="new-wallet" role="tabpanel" aria-labelledby="new-wallet-tab">
                {this.state.thirdActiveTab === 'new-wallet' && <div className="fixed-market-grid">

                  {this.state.new_wallet.slice(0, FIXED_GRID_SIZE).map((minirecord, index) => (
                    SHOW_AD_PLACEHOLDER ? this.renderAdBox(`new-wallet${index}`) : (
                    <div className="item" key={`wallet${index}`}>
                      <a href={minirecord.website_url} target="_blank" className="one-five" style={{ 'textDecoration': 'none' }}>
                        <div className="market-list">

                          <div className="market-top">
                            <strong>
                              {
                                minirecord.logo_url !== '' &&
                                <strong><img alt="" src={minirecord.logo_url} style={{ 'width': '36px', 'height': '36px' }} /></strong>
                              }
                            </strong>
                            <div className="market-list-right">
                              <h3>{minirecord.name}</h3>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                    )
                  ))}

                </div>}
              </div>
               <div className="tab-pane fade" id="new-blockchain" role="tabpanel" aria-labelledby="new-blockchain-tab">
                {this.state.thirdActiveTab === 'new-blockchain' && <div className="fixed-market-grid">

                  {this.state.new_blockchain.slice(0, FIXED_GRID_SIZE).map((minirecord, index) => (
                    SHOW_AD_PLACEHOLDER ? this.renderAdBox(`new-blockchain${index}`) : (
                    <div className="item" key={`blockchain${index}`}>
                      <div className="item" key={`blockchain${index}`}>

                    <a href={minirecord.url} target="_blank" className="one-five" style={{ 'textDecoration': 'none' }}>
                        <div className="market-list">

                          <div className="market-top">
                            <strong>
                              {
                                minirecord.logo !== '' &&
                                <strong><img alt="" src={minirecord.logo} style={{ 'width': '36px', 'height': '36px' }} /></strong>
                              }
                            </strong>
                            <div className="market-list-right">
                              <h3>{minirecord.name}</h3>
                            </div>
                          </div>
                        </div>
                      </a>



                    </div>
                    </div>
                    )
                  ))}

                </div>}
              </div>
            </div>
            </div>

            <div className="text-center mid-ad-div">
              <div className="advertisements">
              {this.state.ads.map((ad, index) => {
                if (ad.add_number == 32) {
                  return (
                    <div className="ad container text-center">
                        <a href={`${this.state.api_url}advertise`} target="_blank"><img src={this.state.uploaded_image_url + ad.image} alt="Advertisement" className="img-fluid full-img mobilehide-ad" /></a>
                    </div>
                  );
                }
                else {
                  return null; // important to return something
                }
              })}
            </div>
            </div>

              <div className="">
             <div className="exchanges-top-search">

                <ul className="nav nav-pills" id="myTab3" role="tablist">
                  <li className="nav-item">
                    <a onClick={() => {
                      this.get_utility();
                      this.setState({fourthActiveTab: 'utility'})
                    }} className="nav-link active" id="new-utility-game-tab" data-toggle="tab" href="#new-utility-game" role="tab" aria-controls="new-utility-game" aria-selected="false" ><Trans>New Arrival Utility Games</Trans></a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" id="earn-crypto-tab" data-toggle="tab" href="#earn-crypto" role="tab" aria-controls="earn-crypto" aria-selected="false" onClick={() => {
                      this.get_earn_crypto();
                      this.setState({fourthActiveTab: 'earn-crypto'})}}><Trans>Earn Cryptos</Trans></a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" id="merchant-tab" data-toggle="tab" href="#merchant" role="tab" aria-controls="merchant" aria-selected="false" onClick={() => {
                      this.get_crypto_merchants();
                      this.setState({fourthActiveTab: 'merchant'})
                      }}><Trans>Merchants</Trans></a>
                  </li>
                </ul>

                <div className="clearfix"></div>
              </div>

            <div className="tab-content" id="myTab4Content">
               <div className="tab-pane fade show active" id="new-utility-game" role="tabpanel" aria-labelledby="new-utility-game-tab">
                  {this.state.fourthActiveTab === 'utility' && <div className="fixed-market-grid">

                  {this.state.utility.slice(0, FIXED_GRID_SIZE).map((minirecord, index) => (
                    SHOW_AD_PLACEHOLDER ? this.renderAdBox(`utility${index}`) : (
                    <div className="item" key={`sponsor${index}`}>
                      <a href={minirecord.website} target="_blank" className="one-five" style={{ 'textDecoration': 'none' }}>
                        <div className="market-list">

                          <div className="market-top">
                            <strong>
                              {
                                minirecord.logo_url !== '' &&
                                <strong><img alt="" src={minirecord.logo_url} style={{ 'width': '36px', 'height': '36px' }} /></strong>
                              }
                            </strong>
                            <div className="market-list-right">
                              <h3>{minirecord.name}</h3>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                    )
                  ))}
                </div>}
              </div>
               <div className="tab-pane fade" id="earn-crypto" role="tabpanel" aria-labelledby="earn-crypto-tab">
                {this.state.fourthActiveTab === 'earn-crypto' && <div className="fixed-market-grid">

                  {this.state.earn_crypto.slice(0, FIXED_GRID_SIZE).map((minirecord, index) => (
                    SHOW_AD_PLACEHOLDER ? this.renderAdBox(`earn-crypto${index}`) : (
                    <div className="item" key={`earn_crypto${index}`}>
                      <a href={minirecord.website} target="_blank" className="one-five" style={{ 'textDecoration': 'none' }}>
                        <div className="market-list">

                          <div className="market-top">
                            <strong>
                              {
                                minirecord.logo_url !== '' &&
                                <strong><img alt="" src={minirecord.logo_url} style={{ 'width': '36px', 'height': '36px' }} /></strong>
                              }
                            </strong>
                            <div className="market-list-right">
                              <h3>{minirecord.name}</h3>
                              <p>{minirecord.symbol}</p>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                    )
                  ))}

                </div>}
              </div>

              <div className="tab-pane fade" id="merchant" role="tabpanel" aria-labelledby="merchant-tab">
                {this.state.fourthActiveTab === 'merchant' && <div className="fixed-market-grid">

                  {this.state.crypto_merchants.slice(0, FIXED_GRID_SIZE).map((minirecord, index) => (
                    SHOW_AD_PLACEHOLDER ? this.renderAdBox(`merchant${index}`) : (
                    <div className="item" key={`crypto_merchants${index}`}>
                      <a href={minirecord.category} target="_blank" className="one-five" style={{ 'textDecoration': 'none' }}>
                        <div className="market-list">

                          <div className="market-top">
                             <strong>
                              {
                                minirecord.logo_url !== '' &&
                                <strong><img alt="" src={minirecord.logo_url} style={{ 'width': '36px', 'height': '36px' }} /></strong>
                              }
                            </strong>
                            <div className="market-list-right">
                              <h3>{minirecord.name}</h3>
                              <p>{minirecord.crypto_support}</p>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                    )
                  ))}

                </div>}
              </div>
            </div>
            </div>


            <div className="text-center mid-ad-div">
              <div className="advertisements">
              {this.state.ads.map((ad, index) => {
                if (ad.add_number == 33) {
                  return (
                    <div className="ad container text-center">
                        <a href={`${this.state.api_url}advertise`} target="_blank"><img src={this.state.uploaded_image_url + ad.image} alt="Advertisement" className="img-fluid full-img mobilehide-ad" /></a>
                    </div>
                  );
                }
                else {
                  return null; // important to return something
                }
              })}
            </div>
            </div>

            <div className="currencies-favaourites-inner">

              <div className="exchanges-top-search">

                <ul className="nav nav-pills" id="myTab" role="tablist">
                  <li className="nav-item">
                    <a className="nav-link active" id="currencies-tab" data-toggle="tab" href="#currencies" role="tab" aria-controls="currencies" aria-selected="true" onClick={() => this.loadPage(this.state.showCurrency)}><Trans>All Currencies</Trans></a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" id="favaourites-tab" data-toggle="tab" href="#favaourites" role="tab" aria-controls="favaourites" aria-selected="false" onClick={() => this.favCrypto(this.state.showCurrency)}><Trans>Favourites</Trans></a>
                  </li>
                </ul>

                <div className="clearfix"></div>
              </div>

              <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active" id="currencies" role="tabpanel" aria-labelledby="currencies-tab">

                  <div className="table-responsive big-table">

                    <div className="div-base-table">
                      <div className="div-base-table-head" id="div-base-table-head">
                        <div className="div-base-table-head-inner">
                          <div className="thead-col">Cryptocurrency</div>
                          <div className="thead-col">
                            <span className="action-text-right">Price(USD)</span>
                          </div>
                          <div className="thead-col">
                            <span className="action-text-right">Price Graph(7D)</span>
                          </div>
                          <div className="thead-col">
                            <span className="action-text-right">Market Cap</span>
                          </div>
                          <div className="thead-col">
                            <span className="action-text-right">24hr Volume</span>
                          </div>
                          <div className="thead-col">
                            <span className="action-text-right">Action</span>
                          </div>
                        </div>
                      </div>

                      <div className="line-break"></div>

                      <div className="div-base-table-body">
                        {
                          this.state.loading ? <div className="holds-the-iframe" style={{ 'height': '150px' }}>&nbsp;</div> : this.state.dataLength < 1 ? <div style={{ 'textAlign': 'center', 'fontSize': '17px', 'fontWeight': 'bold', 'marginTop': '20px', 'marginBottom': '20px' }} >No Records Found</div> : this.state.postData
                        }
                      </div>
                    </div>

                    <div className="clearfix">&nbsp;</div>
                     
                  </div>

                </div>

                <div className="tab-pane fade" id="favaourites" role="tabpanel" aria-labelledby="favaourites-tab">
                  <div className="table-responsive big-table">

                    <div className="div-base-table">
                      <div className="div-base-table-head" id="div-base-table-head">
                        <div className="div-base-table-head-inner">
                          <div className="thead-col">Cryptocurrency</div>
                          <div className="thead-col">
                            <span className="action-text-right">Price(USD)</span>
                          </div>
                          <div className="thead-col">
                            <span className="action-text-right">Price Graph(7D)</span>
                          </div>
                          <div className="thead-col">
                            <span className="action-text-right">Market Cap</span>
                          </div>
                          <div className="thead-col">
                            <span className="action-text-right">24hr Volume</span>
                          </div>
                          <div className="thead-col">
                            <span className="action-text-right">Action</span>
                          </div>
                        </div>
                      </div>

                      <div className="line-break"></div>

                      <div className="div-base-table-body">
                        {
                          this.state.loading ? <div className="holds-the-iframe" style={{ 'height': '150px' }}>&nbsp;</div> : this.state.dataLength < 1 ? <div style={{ 'textAlign': 'center', 'fontSize': '17px', 'fontWeight': 'bold', 'marginTop': '20px', 'marginBottom': '20px' }} >No Records Found</div> : this.state.favData
                        }

                        
                      </div>

                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>
        <section className="latest-news-services">
          <div className="container">
            <h2 className="section-title wow bounceInDown" data-wow-delay="0.4s">Latest <span className="underline"><Trans>News</Trans></span></h2>
            <div className="intro wow bounceInDown" data-wow-delay="0.5s"><Trans>The latest breaking news around crypto world</Trans></div>
            <div className="row">
              {this.state.latestnewsData}
            </div>
            <div className="clearfix">&nbsp;</div>
            {this.state.total_news_length !== this.state.current_news_length &&
              <div className="text-center">
                <a href="#!" className="btn btn-primary btn-lg" onClick={() => { this.loadMoreNews() }}><span><Trans>Load More</Trans></span></a>
              </div>
            }
          </div>
        </section>
	<NewFooter />
      </div>
    )
  }
}
export default withTranslation('translations')(Home);